import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import { AlertContext } from "../../../context/AlertContext";
import { Link, Redirect } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { styled, ThemeProvider } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import Barra from "../Barra";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import QRCode from "react-qr-code";

export default function QrEmersur(props) {
  //const classes = useStyles();
  const [band, setBand] = useState(true);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(null);

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, configuracion, obtenerAcceso, obtenerConfiguracion } =
    configuracionContext;

  const theme = createBrandTheme(getBrand(configuracion));

  const toast = useRef(null);
  let navigate = useNavigate();

  useEffect(() => {
    usuarioAutenticado();
  }, [state.id]);

  useEffect(() => {
    obtenerConfiguracion();
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const estado = async (e) => {
    if (configuracion.destinatario === 1) {
      const options = {
        method: "GET",
        headers: {
          accept: "application/json",
          authorization: `Bearer ${configuracion.whapi}`,
        },
      };

      const response = await fetch(
        "https://gate.whapi.cloud/health?wakeup=true&channel_type=web",
        options
      );
      const result = await response.json();
      //console.log(result.status);
      setStatus(result.status.text);
    }

    if (configuracion.destinatario !== 1) {
      const response = await fetch("https://www.wasenderapi.com/api/status", {
        method: "GET",
        headers: {
          Authorization: `Bearer 1e17ec2535011cf5a1f3dfe35b582b213089bd1ca1e993de7d14b60149dcb42f`,
        },
      });
      const result = await response.json();
      //console.log(result.status);
      setStatus(result.status);
    }
  };

  const aceptarClick = async (e) => {
    e.preventDefault();

    setBand(false);

    if (configuracion.destinatario === 1) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Access-Control-Allow-Origin", "*");
      myHeaders.append("Authorization", `Bearer ${configuracion.whapi}`);

      const options = {
        method: "GET",
        headers: myHeaders,
        /*
      headers: {
        accept: "application/json",
        authorization: `Bearer ${configuracion.whapi}`,
      },
      */
      };

      let response = await fetch(
        "https://gate.whapi.cloud/users/login?wakeup=true",
        options
      );

      if (response.ok) {
        const json = await response.json();
        if (json && json.status && json.status === "OK") {
          let array = json.base64.split(",");
          setData(array[1]);
        } else {
          //window.location.reload();
        }
      }
    }

    if (configuracion.destinatario === 2) {
      async function conectarSesion() {
        const idSesion = "47118"; // ¡Reemplaza! Ej: '1'

        const response = await fetch(
          `https://www.wasenderapi.com/api/whatsapp-sessions/${idSesion}/connect`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_WASENDER_TOKEN}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const json = await response.json();
          if (json && json.success) {
            let qr = json.data.qrCode;
            console.log(qr);
            setData(qr);
          } else {
            //window.location.reload();
          }
        }
      }
      conectarSesion();
    }

    if (configuracion.destinatario === 4) {
      async function conectarSesion() {
        const idSesion = "43570"; // ¡Reemplaza! Ej: '1'

        const response = await fetch(
          `https://www.wasenderapi.com/api/whatsapp-sessions/${idSesion}/connect`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_WASENDER_TOKEN}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const json = await response.json();
          if (json && json.success) {
            let qr = json.data.qrCode;
            console.log(qr);
            setData(qr);
          } else {
            //window.location.reload();
          }
        }
      }
      conectarSesion();
    }

    if (configuracion.destinatario === 6) {
      async function conectarSesion() {
        const idSesion = "45633"; // ¡Reemplaza! Ej: '1'

        const response = await fetch(
          `https://www.wasenderapi.com/api/whatsapp-sessions/${idSesion}/connect`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_WASENDER_TOKEN}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const json = await response.json();
          if (json && json.success) {
            let qr = json.data.qrCode;
            console.log(qr);
            setData(qr);
          } else {
            //window.location.reload();
          }
        }
      }

      conectarSesion();
    }
  };

  const exitClick = (e) => {
    navigate(`/`);
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  if (!status && configuracion) {
    estado();
  }

  return (
    <ThemeProvider theme={theme}>
      <Toast ref={toast} />
      <Fragment>
        <Fragment>
          <Grid container spacing={3} style={{ margin: "3vw" }}>
            <Grid item xs={10} md={8}>
              <h1 style={{ textAlign: "center" }}>WhatsApp QR Emersur Cobranzas</h1>
              <h2 style={{ textAlign: "center" }}>{"Estado: " + status}</h2>
            </Grid>

            {configuracion && configuracion.whapi && band ? (
              <Fragment>
                <Grid item xs={10} md={12} />
                <Grid item xs={10} md={12} />
                <Grid item xs={12} md={12} />
                <Grid item xs={12} md={12} />
                <Grid item xs={12} md={3} style={{ marginTop: "10em" }}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    onClick={aceptarClick}
                  >
                    Generar
                  </Button>
                </Grid>
                <Grid item xs={12} md={3} style={{ marginTop: "7.4em" }}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "red", marginTop: "3em" }}
                    onClick={exitClick}
                  >
                    Salir
                  </Button>
                </Grid>
              </Fragment>
            ) : null}

            {configuracion && configuracion.whapi && !band && data ? (
              <Fragment>
                {configuracion && configuracion.destinatario !== 1 ? (
                  <Grid item xs={12} md={6} style={{ marginTop: "10em" }}>
                    <QRCode
                      value={data}
                      size={256}
                      style={{ height: "auto", maxWidth: "50%", width: "50%" }}
                      viewBox={`0 0 256 256`}
                    />{" "}
                    <Button
                      type="button"
                      fullWidth
                      variant="contained"
                      style={{ backgroundColor: "red", marginTop: "3em" }}
                      onClick={exitClick}
                    >
                      Salir
                    </Button>
                  </Grid>
                ) : (
                  <Grid item xs={12} md={6} style={{ marginTop: "2em" }}>
                    <img src={`data:image/jpeg;base64,${data}`} />
                    <Button
                      type="button"
                      fullWidth
                      variant="contained"
                      style={{ backgroundColor: "red", marginTop: "3em" }}
                      onClick={exitClick}
                    >
                      Salir
                    </Button>
                  </Grid>
                )}

                <Grid item xs={10} md={4}></Grid>
              </Fragment>
            ) : null}
          </Grid>
        </Fragment>
      </Fragment>
    </ThemeProvider>
  );
}
